import {
    ValidateTelFunction,
    ValidateFormFunction,
} from "./types"
import { TEL_LENGTH, REGEX_TEL, TEL_ERROR_MESSAGES } from "../../../../constants/progressBanner"

export const validateTel: ValidateTelFunction = async (tel, touched) => {
    if (!tel && touched) {
        return TEL_ERROR_MESSAGES.REQUIRED
    }

    if (tel && !/^\d+$/.test(tel)) {
        return TEL_ERROR_MESSAGES.NUMBERS_ONLY
    }

    if (tel && tel.length !== TEL_LENGTH.MIN) {
        return TEL_ERROR_MESSAGES.INVALID_LENGTH
    }

    if (tel && tel.length === TEL_LENGTH.MIN && !REGEX_TEL.test(tel)) {
        return TEL_ERROR_MESSAGES.INVALID_FORMAT
    }

    if (tel) {
        try {
            const response = await fetch("/api/v1/users/check_tel_if_registered", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user: { tel: tel },
                }),
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()
            if (!data) {
                return TEL_ERROR_MESSAGES.ALREADY_REGISTERED
            }
        } catch (error) {
            return TEL_ERROR_MESSAGES.SERVER_ERROR
        }
    }
}

export const validateForm: ValidateFormFunction = async (
    tel,
    touched
) => {
    const telError = await validateTel(tel, touched.tel)

    return {
        errors: {
            tel: telError,
        },
        isValid:
            tel !== "" && !telError,
    }
}